import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faPrint,
  faQrcode,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import urls from "../urls";
import { useSelector } from "react-redux";

const TableRow = ({
  inventory_item_id,
  id,
  item_use_place,
  inventoryCode,
  item_name,
  showEditItem,
  handleDeleteItem,
  n,
  token,
  onRemoveFromStock,
}) => {
  const user_type = useSelector((state) => state.userState.userType);

  return (
    <tr
      key={id}
      className="align-middle text-center"
      style={{ fontSize: "12px" }}
    >
      <td>{n}</td>

      <td>{inventoryCode}</td>
      <td style={{ maxWidth: "150px" }}>
        <div className="text-truncate">{item_name}</div>
      </td>
      <td>{!item_use_place ? "المخزن " : item_use_place}</td>
      <td>
        {item_use_place && (
          <>
            <a
              className="btn border border-1"
              title="Edit"
              href={urls.printInventoryQRCode(token)}
              target="_blank"
            >
              <FontAwesomeIcon icon={faQrcode} size="lg" />
            </a>
            <button
              className="btn btn-warning   ms-3"
              onClick={() => handleDeleteItem(id)}
            >
              إرجاع الى المخزن
            </button>
          </>
        )}

        {user_type === "admin" && (
          <button
            className="btn btn-danger  ms-3"
            title="Delete"
            onClick={() => onRemoveFromStock(inventory_item_id)}
          >
            حذف من المخزن
          </button>
        )}
      </td>
    </tr>
  );
};

const InventoryTableRows = ({
  showEditItem,
  handleDeleteItem,
  data,
  onRemoveFromStock,
}) => {
  return (
    <>
      {data.map((item, idx) => (
        <TableRow
          inventory_item_id={item.inventory_item_id}
          n={idx + 1}
          key={"inventory-idx-" + idx}
          id={item.id}
          item_use_place={item.place_name}
          inventoryCode={item.inventoryCode}
          item_name={item.item_name}
          showEditItem={showEditItem}
          handleDeleteItem={handleDeleteItem}
          token={item.token}
          onRemoveFromStock={onRemoveFromStock}
        />
      ))}
    </>
  );
};

export default InventoryTableRows;
